import React, { ChangeEvent } from 'react'
import { Form, Input } from 'semantic-ui-react'
import styles from './styles.module.less'

export interface Props {
  value?: string
  className?: string
  name: string
  label: string
  maxCharacters: number
  onChange: (e: ChangeEvent<Element>) => void
  onBlur: (e: ChangeEvent<Element>) => void
  error?: { content: string } | null
}

export const CharacterCountInput = ({
  label,
  className,
  maxCharacters,
  name,
  value,
  onChange,
  onBlur,
  error,
}: Props) => {
  const characterCount = value?.length || 0
  const hasError = characterCount > maxCharacters
  return (
    <Form.Field error={error || hasError}>
      <label htmlFor={`#${name}-character-count`} className={styles.characterCountLabel}>
        <span>{label}</span>
        <span className={`test-character-count ${styles.characterCount} ${hasError ? styles.errorColor : ''}`}>
          {characterCount}/{maxCharacters}
        </span>
      </label>
      <Input
        className={className}
        data-testid={'input-limit'}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
      {hasError && (
        <div className="ui pointing above prompt label test-input-count-error" role="alert" aria-atomic="true">
          Cannot have more than {maxCharacters} characters
        </div>
      )}
    </Form.Field>
  )
}
